/**
 * SG — Change of financial year end (Director’s Resolution in Writing)
 * 템플릿 [[...]] 키와 정렬 (스크린샷 DR Change of FYE.docx 기준).
 */

export interface ChangeFinancialYearEndInput {
  company_name: string;
  company_registration_no: string;
  current_fye_date: string;
  new_fye_date: string;
  new_financial_period_months: string | number;
  next_fy_start_date: string;
  next_fy_end_date: string;
  csp_name: string;
  resolution_date: string;
  /** 서명자 표기 — 템플릿 `[[Signers]]` (미사용 시 빈 문자열) */
  Signers?: string;
}

function trim(s: unknown): string {
  return s === null || s === undefined ? '' : String(s).trim();
}

export function buildChangeFinancialYearEndVariables(input: Partial<ChangeFinancialYearEndInput>): Record<string, any> {
  const months = trim(input.new_financial_period_months);
  return {
    company_name: trim(input.company_name),
    company_registration_no: trim(input.company_registration_no),
    current_fye_date: trim(input.current_fye_date),
    new_fye_date: trim(input.new_fye_date),
    new_financial_period_months: months,
    next_fy_start_date: trim(input.next_fy_start_date),
    next_fy_end_date: trim(input.next_fy_end_date),
    csp_name: trim(input.csp_name),
    resolution_date: trim(input.resolution_date),
    Signers: trim(input.Signers ?? ''),
  };
}

/** ACRA Save FYE API — financialYearEndPeriod 코드 */
export type FyeFilingPeriodCode = '12M' | '52W';

export function mapFinancialYearEndPeriodToFilingCode(period: string | number | undefined | null): FyeFilingPeriodCode {
  const s = String(period ?? '').trim().toLowerCase();
  if (s.includes('52')) return '52W';
  return '12M';
}

function normalizeUen(raw: string): string {
  return String(raw || '').replace(/\s/g, '').trim();
}

/**
 * L_TASK_EFILING_DATA.REQUEST_PAYLOAD 용 — eFilingDataForApi 구조
 * revisedFinancialYearEndDate: 화면 new_fye_date (YYYY-MM-DD)
 */
export function buildChangeFyeEfilingRequestPayload(params: {
  newFyeDate: string;
  newFinancialPeriodMonths: string;
  filingAgentUen: string;
  entityUen: string;
}): { eFilingDataForApi: Record<string, unknown> } {
  const revised = trim(params.newFyeDate);
  const periodCode = mapFinancialYearEndPeriodToFilingCode(params.newFinancialPeriodMonths);
  const agent = normalizeUen(params.filingAgentUen);
  const entity = normalizeUen(params.entityUen);
  return {
    eFilingDataForApi: {
      SaveFYEList: [
        {
          revisedFinancialYearEndDate: revised,
          financialYearEndPeriod: periodCode,
          changeReasons: [],
          otherReason: '',
          supportingDocuments: [],
        },
      ],
      FilingAgentUEN: agent,
      EntityUEN: entity,
    },
  };
}
